// commit-owner-skipped-pathspecs-line.ts
//
// The operator line for manifest pathspecs commit-owner skipped (review 260930
// L5). `allowed_paths` can be authored by a worker (proposals), so the text is
// bounded and sanitised before it reaches a terminal (review 261001 L6): at most
// MAX_LISTED entries then "(+N nữa)", each cut at MAX_ENTRY_CHARS, and every
// control character (ANSI escapes, newlines, NUL) replaced by "?".
import { clipUntrustedText, replaceControlChars } from "./clip-untrusted-text.js";

const MAX_LISTED = 10;
const MAX_ENTRY_CHARS = 120;

const clip = (entry: string): string => clipUntrustedText(entry, MAX_ENTRY_CHARS);

export function formatSkippedPathspecsLine(ticketRef: string, skipped: string[]): string {
  const listed = skipped.slice(0, MAX_LISTED).map(clip).join(", ");
  const rest = skipped.length - MAX_LISTED;
  return (
    `Commit ${replaceControlChars(ticketRef)}: bỏ qua pathspec không có file để stage: ${listed}` +
    `${rest > 0 ? ` (+${rest} nữa)` : ""} ` +
    '(không khớp file nào, chỉ khớp file bị gitignore, hoặc bắt đầu bằng ":").'
  );
}
